module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/issue-275.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/contribution/issue.md
// module id = 718
// module chunks = 426